import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { useState, useEffect } from "react";
import { Shield, Clock, CreditCard, Zap, Trophy, Target, Activity } from "lucide-react";

const PaymentProcessing = (props) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    return 100;
                }
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 100);
            });
        }, 200);

        return () => {
            clearInterval(timer);
        };
    }, []);

    // const dd=(
    //     <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
    //     <div className="bg-flup-surface p-8 rounded-xl shadow-2xl text-center max-w-md mx-4 relative overflow-hidden">
    //         <div className="absolute inset-0 bg-gradient-to-r from-yellow-100 to-pink-100 opacity-30"></div>

    //         <div className="relative z-10">
    //             <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
    //                 <svg
    //                     className="w-12 h-12 text-green-600"
    //                     fill="none"
    //                     stroke="currentColor"
    //                     viewBox="0 0 24 24"
    //                 >
    //                     <path
    //                         strokeLinecap="round"
    //                         strokeLinejoin="round"
    //                         strokeWidth="2"
    //                         d="M5 13l4 4L19 7"
    //                     />
    //                 </svg>
    //             </div>

    //             <h2 className="text-3xl font-bold text-flup-ink mb-3">Congratulation!</h2>
    //             <p className="text-flup-ink-2 mb-6">
    //                 YourOnboarding  has been completed.
    //             </p>
    //             <p className="text-flup-ink-2 mb-6">
    //                 Please pay onetime onboarding fee of <span className='font-bold text-black-700'> INR: 600 </span> to list youe venue.
    //             </p>

    //             <div className='flex items-center justify-center space-x-4'>
    //                 <button
    //                     onClick={onClose}
    //                     className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-md"
    //                 >
    //                     Continue
    //                 </button>
    //                 <ButtonWithLoader
    //                     onClick={() => { }}
    //                     className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-md"
    //                 >
    //                     Paynow
    //                 </ButtonWithLoader>
    //             </div>

    //         </div>

    //     </div>
    // </div>
    // )

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 ">
            {/* <div className="min-h-screen bg-gradient-to-br from-green-400 via-blue-500 to-purple-600 flex items-center justify-center p-4"> */}
            {/* Background Sports Elements */}
            {/* <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full animate-bounce"></div>
                    <div className="absolute top-32 right-20 w-16 h-16 bg-white/10 rounded-full animate-pulse"></div>
                    <div className="absolute bottom-20 left-1/4 w-12 h-12 bg-white/10 rounded-full animate-bounce delay-300"></div>
                    <div className="absolute bottom-32 right-1/3 w-14 h-14 bg-white/10 rounded-full animate-pulse delay-500"></div>

                    <div className="absolute top-16 left-1/4 text-white/20 animate-pulse delay-1000">
                        <Trophy size={32} />
                    </div>
                    <div className="absolute top-40 right-1/4 text-white/20 animate-bounce delay-700">
                        <Target size={28} />
                    </div>
                    <div className="absolute bottom-40 left-20 text-white/20 animate-pulse delay-300">
                        <Activity size={36} />
                    </div>
                    <div className="absolute bottom-16 right-20 text-white/20 animate-bounce delay-500">
                        <Zap size={30} />
                    </div>
                    <div className="absolute top-1/2 left-16 text-white/20 animate-pulse delay-200">
                        <Trophy size={24} />
                    </div>
                    <div className="absolute top-1/3 right-16 text-white/20 animate-bounce delay-800">
                        <Target size={26} />
                    </div>
                    <div className="absolute top-3/4 left-1/3 text-white/20 animate-pulse delay-600">
                        <Activity size={32} />
                    </div>
                    <div className="absolute top-20 right-1/3 text-white/20 animate-bounce delay-400">
                        <Zap size={28} />
                    </div>
                </div> */}

            <div className="relative z-10 max-w-md w-full">
                <Card className="bg-flup-surface/95 backdrop-blur-sm shadow-2xl border-0">
                    <CardContent className="p-8 text-center space-y-6">
                        {/* Payment Icon with Animation */}
                        <div className="flex justify-center">
                            <div className="relative">
                                <div className="w-20 h-20 bg-flup-brand hover:bg-flup-brand-press text-white rounded-full flex items-center justify-center animate-pulse">
                                    <CreditCard className="w-10 h-10 text-white" />
                                </div>
                                <div className="absolute -top-1 -right-1 w-6 h-6 bg-green-500 rounded-full animate-bounce">
                                    <div className="w-full h-full rounded-full border-2 border-white"></div>
                                </div>
                            </div>
                        </div>

                        {/* Processing Title */}
                        <div>
                            <h1 className="text-2xl font-bold text-flup-ink mb-2">
                                Processing Your Payment
                            </h1>
                            <p className="text-flup-ink-2">
                                Please wait while we securely process your transaction
                            </p>
                        </div>

                        {/* Progress Bar */}
                        <div className="space-y-2">
                            <Progress value={progress} className="h-3" />
                            <p className="text-sm text-flup-ink-3">
                                {Math.round(progress)}% Complete
                            </p>
                        </div>

                        {/* Security Features */}
                        <div className="flex items-center justify-center gap-6 text-sm text-flup-ink-2">
                            <div className="flex items-center gap-2">
                                <Shield className="w-4 h-4 text-green-500" />
                                <span>Secure</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <Clock className="w-4 h-4 text-flup-info" />
                                <span>Fast</span>
                            </div>
                        </div>

                        {/* Status Messages */}
                        <div className="space-y-2">
                            <div className="flex items-center justify-between text-sm">
                                <span className="text-flup-ink-2">Verifying payment details</span>
                                <span className="text-green-500">✓</span>
                            </div>
                            <div className="flex items-center justify-between text-sm">
                                <span className="text-flup-ink-2">Processing transaction</span>
                                <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                            </div>
                            <div className="flex items-center justify-between text-sm text-flup-ink-3">
                                <span>Confirming booking</span>
                                {props?.isPaymentcompleted ? <span className="text-green-500">✓</span> :
                                    // <span>○</span>
                                    <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>

                                }


                            </div>
                        </div>

                        {/* Important Notice */}
                        <div className="bg-flup-info-soft border border-flup-info/20 rounded-lg p-4">
                            <p className="text-xs text-flup-info">
                                <strong>Important:</strong> Please do not close this window or navigate away while we process your payment.
                            </p>
                        </div>
                    </CardContent>
                </Card>
            </div>
            {/* </div> */}
        </div>
    );
};

export default PaymentProcessing;
